import {
  Box,
  FormField,
  FormHelp,
  Label,
  LabeledControl,
  Paragraph,
  Radio,
  Text,
  Textarea,
} from '@zillow/constellation-10';

import { deactivationReasons, REASONS } from '../constants';

const DeactivationReason = ({ onReasonSelection, reason, onFeedbackChange }) => {
  return (
    <>
      <Paragraph textStyle="heading-xs" css={{ marginBottom: '200' }}>
        Why are you deactivating this listing?
      </Paragraph>
      <Paragraph css={{ marginBottom: '200' }}>Your answer helps us direct you to the right next step.</Paragraph>
      {deactivationReasons.map((option) => (
        <LabeledControl
          key={option.name}
          label={<Label>{option.label}</Label>}
          control={
            <Radio
              name={option.name}
              onChange={() => onReasonSelection(option.name)}
              checked={reason === option.name}
            />
          }
        />
      ))}
      {reason === REASONS.OTHER && (
        <>
          <Box css={{ marginBottom: '100' }}>
            <Text textStyle="body-sm-bold" asChild>
              <span>Add details</span>
            </Text>
            <Text> (optional)</Text>
          </Box>
          <FormField>
            <Textarea maxLength="500" onChange={onFeedbackChange} />
            <FormHelp>Max 500 characters</FormHelp>
          </FormField>
        </>
      )}
    </>
  );
};

export default DeactivationReason;
